import {
  Box,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { FaFileCode } from "react-icons/fa";
import { VisitInstanceId } from "../../../shared/schema/schema";
import { SandataPayloadModalContent } from "./SandataPayloadModal";

interface SandataPayloadCellProps {
  visitInstanceId: VisitInstanceId;
  evvAggregator: string | null;
  /** Whether the visit has any Sandata submission on record. */
  hasSandataSubmission: boolean;
}

export function SandataPayloadCell({
  visitInstanceId,
  evvAggregator,
  hasSandataSubmission,
}: SandataPayloadCellProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Only Sandata records payloads, and only a visit that has been submitted has
  // anything to show. The submission row is the cheap proxy for that: it is
  // already on the page, whereas the attempt count is not known until the modal
  // fetches.
  if (evvAggregator?.toLowerCase() !== "sandata" || !hasSandataSubmission) {
    return <span>-</span>;
  }

  return (
    <>
      <Tooltip label="View payloads sent to Sandata" placement="top">
        <Box
          _hover={{ opacity: 0.7 }}
          as="button"
          cursor="pointer"
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            onOpen();
          }}
        >
          <Icon as={FaFileCode} boxSize={4} color="blue.500" />
        </Box>
      </Tooltip>

      {/* Mounted only while open so the fetch is genuinely lazy — one request
          per visit the operator actually looks at, not per row on the page. */}
      {isOpen && (
        <Modal isOpen={isOpen} size="3xl" onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Sandata Submission Payloads</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <SandataPayloadModalContent visitInstanceId={visitInstanceId} />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}
